import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Chargepoint } from '../../api/chargepoints-api.service';
import { Diagnostic, DiagnosticsApiService } from '../../api/diagnostics-api.service';
import { catchError, filter, Observable, of, switchMap, tap } from 'rxjs';
import { RefreshService } from '../common/refresh-widget/refresh.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';

@Component({
  selector: 'app-chargepoint-diagnostics',
  templateUrl: './chargepoint-diagnostics.component.html',
  styleUrls: ['./chargepoint-diagnostics.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatProgressBarModule,
    MatTableModule
  ]
})
export class ChargepointDiagnosticsComponent implements OnInit {

  @Input() chargepoint!: Chargepoint;

  public diagnostics$: Observable<Diagnostic[]>;
  public loading = false;
  public fetchingError = false;

  constructor(private diagnosticsApiService: DiagnosticsApiService, private refreshService: RefreshService) {
    this.diagnostics$ = this.refreshService.refreshTrigger.pipe(
      filter(() => !!this.chargepoint),
      tap(() => {
        this.loading = true;
        this.fetchingError = false;
      }),
      switchMap(() => this.diagnosticsApiService.searchDiagnostics({chargepointId: this.chargepoint.id})),
      tap(() => {
        this.loading = false;
        this.fetchingError = false;
      }),
      catchError(() => {
        this.loading = false;
        this.fetchingError = true;
        return of([]);
      }),
      filter(diagnostics => diagnostics !== null),
    );
  }

  ngOnInit() {
  }

  downloadDiagnostic(diagnostic: Diagnostic) {
    this.diagnosticsApiService.downloadDiagnostic(diagnostic.id).subscribe(response => {
      const blob = new Blob([response], { type: diagnostic.contentType });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = diagnostic.filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }
}
